import * as React from 'react';
import { configure } from 'mobx';
import { hydrateRoot } from 'react-dom/client';
configure({ enforceActions: 'observed', isolateGlobalState: true });
import { Provider } from 'mobx-react';
import FlexibleSetPage from './components/flexibleSetPage/flexibleSetPage';
import { MainStore } from './stores/MainStore';
import './styles/thirdPartyStyles/styles';
import { IResponseData } from './stores/types';
import './styles/baseStyles.scss';

// best-effort pageview logging (non-blocking)
function logPageLoad(state: IResponseData): void {
    try {
        const urlToHost = state?.contextData?.apiMagicLink.replace('api/', '');
        const apiUrl = urlToHost + 'api/flexiblesetpage/pageload';
        fetch(apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({})
        }).catch(() => { /* ignore */ });
    } catch {
        // ignore
    }
}

function hydrateApp() {
    // remove category query param if present
    const url = new URL(window.location.href);
    if (url.searchParams.has('category')) {
        url.searchParams.delete('category');
        window.history.replaceState({}, document.title, url.toString());
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const state = JSON.parse(JSON.stringify(window.__PRELOADED_FSP_STATE__)) as IResponseData;
    const store: MainStore = new MainStore(state);
    delete window.__PRELOADED_FSP_STATE__;

    // fire-and-forget: log a page view to backend on client startup
    logPageLoad(state);

    const container = document.getElementById('flexible-set-page-entry');
    if (!container) {
        throw new Error('flexible-set-page-entry root container element not found');
    }
    hydrateRoot(container,
        <Provider store={store}
            variantStore={store.variantStore}
            mixedMediaStore={store.mixedMediaStore}
            productInfoStore={store.productInfoStore}>
            <FlexibleSetPage />
        </Provider>);
}

hydrateApp();
